import { useLang } from "../i18n/LanguageContext";
import { Snowflake, Flame, MapPin } from "lucide-react";

const PROJECT_IMAGES = [
  "https://customer-assets.emergentagent.com/job_aaron-hvac/artifacts/inpygot8_7411af79-63b6-4332-87bb-353fc9b89141.jpeg", // rooftop Trane AC
  "https://customer-assets.emergentagent.com/job_aaron-hvac/artifacts/o5zha1c4_1161c9e1-957b-4d95-88a9-a927f9445a14.jpeg", // Bryant furnace
];

export const RecentWork = () => {
  const { t } = useLang();
  return (
    <section id="work" data-testid="work-section" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-3xl">
          <span className="text-xs font-semibold uppercase tracking-[0.22em] text-cool" data-testid="work-eyebrow">
            {t.work.eyebrow}
          </span>
          <h2 className="mt-4 font-heading font-bold text-white tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.05]" data-testid="work-title">
            {t.work.title}
          </h2>
          <p className="mt-5 text-white/70 text-base sm:text-lg max-w-2xl">{t.work.subtitle}</p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-testid="work-grid">
          {t.work.items.map((item, i) => {
            const isCool = i === 0;
            const Icon = isCool ? Snowflake : Flame;
            return (
              <article
                key={i}
                data-testid={`work-card-${i}`}
                className={`group relative overflow-hidden rounded-3xl border border-white/10 bg-ink-card transition duration-300 hover:-translate-y-1 ${isCool ? "card-cool" : "card-warm"}`}
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={PROJECT_IMAGES[i]}
                    alt={item.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/10 to-transparent pointer-events-none" />
                  <div className="absolute top-4 left-4 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-ink-card/85 backdrop-blur border border-white/15 text-xs font-semibold">
                    <Icon size={14} className={isCool ? "text-cool" : "text-heat"} />
                    <span className={isCool ? "text-cool" : "text-heat"}>{item.tag}</span>
                  </div>
                </div>
                <div className="p-7">
                  <div className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-white/55">
                    <MapPin size={12} className={isCool ? "text-cool" : "text-heat"} />
                    {item.location}
                  </div>
                  <h3 className="mt-2 font-heading font-bold text-white text-xl sm:text-2xl tracking-tight">{item.title}</h3>
                  <p className="mt-3 text-sm text-white/65 leading-relaxed">{item.desc}</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
